import React from "react";
import { Button } from "semantic-ui-react";
import { InspectionStatus, InspectionStatuses } from "../../citizen-inspection-list/constants/InspectionStatus";

interface InspectionPanelButtonProps {
  isLoading?: boolean;
  status: InspectionStatus;
  onStart?: () => void;
  onComplete?: () => void;
}
export default function InspectionPanelButton({
  status,
  isLoading = false,
  onStart = () => {},
  onComplete = () => {},
}: InspectionPanelButtonProps) {
  // If the inspection has been scheduled, the inspection can be started
  if (status === InspectionStatuses.SCHEDULED) {
    return (
      <Button loading={isLoading} primary fluid onClick={onStart}>
        Start Inspection
      </Button>
    );
  }

  // If the inspection has been started, the inspection can be completed
  if (status === InspectionStatuses.STARTED) {
    return (
      <Button loading={isLoading} primary fluid onClick={onComplete}>
        Complete Inspection
      </Button>
    );
  }

  // If passed, failed, unscheduled, or requested, the inspection cannot be started or completed
  return <></>;
}
